var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8188 4.1445L9.71663 10.026C9.51481 10.1932 9.26096 10.2847 8.99887 10.2847C8.73679 10.2847 8.48294 10.1932 8.28113 10.026L1.18237 4.1445C1.14429 4.25915 1.12491 4.37919 1.125 4.5V13.5C1.125 13.7984 1.24353 14.0845 1.4545 14.2955C1.66548 14.5065 1.95163 14.625 2.25 14.625H15.75C16.0484 14.625 16.3345 14.5065 16.5455 14.2955C16.7565 14.0845 16.875 13.7984 16.875 13.5V4.5C16.8755 4.37925 16.8565 4.25921 16.8188 4.1445ZM2.25 2.25H15.75C16.3467 2.25 16.919 2.48705 17.341 2.90901C17.7629 3.33097 18 3.90326 18 4.5V13.5C18 14.0967 17.7629 14.669 17.341 15.091C16.919 15.5129 16.3467 15.75 15.75 15.75H2.25C1.65326 15.75 1.08097 15.5129 0.65901 15.091C0.237053 14.669 0 14.0967 0 13.5V4.5C0 3.90326 0.237053 3.33097 0.65901 2.90901C1.08097 2.48705 1.65326 2.25 2.25 2.25ZM2.01375 3.375L8.28675 8.55338C8.48766 8.71932 8.73994 8.81037 9.00052 8.81099C9.2611 8.8116 9.51381 8.72174 9.7155 8.55675L16.0515 3.375H2.01375Z",
    fill: "#6A7282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/EmailSent.8a1b8a8657abfc936636bdbb1f7eb968.svg";
export { ForwardRef as ReactComponent };